import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ApprovalTable = ({ requests }) => {
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();

  const handleRowSelect = (requestId) => {
    setSelectedId(requestId);
    navigate(`/request/${requestId}`);
  };

  return (
    <div className="overflow-hidden bg-white rounded shadow-md">
      <div className="relative overflow-x-auto max-h-[75vh] w-full">
        <table className="min-w-[900px] w-full border-collapse table-auto">
          <thead className="sticky top-0 z-10 bg-gray-100">
            <tr>
              <th className="w-10 p-2 text-left bg-gray-100"></th>
              {[
                "Request ID",
                "Created At",
                "Department",
                "Position Type",
                "Assigned",
                "Position Title",
                "Status",
              ].map((header, i) => (
                <th
                  key={i}
                  className="px-4 py-3 text-sm font-semibold text-left text-gray-700 whitespace-nowrap"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="divide-y">
            {Array.isArray(requests) && requests.length > 0 ? (
              requests.map((request, i) => (
                <tr
                  key={request.requestId || i}
                  onClick={() => handleRowSelect(request.requestId)}
                  onKeyDown={(e) =>
                    e.key === "Enter" && handleRowSelect(request.requestId)
                  }
                  tabIndex={0}
                  className={`cursor-pointer hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                    selectedId === request.requestId ? "bg-blue-50" : ""
                  }`}
                >
                  <td className="px-2">
                    <input
                      type="checkbox"
                      checked={selectedId === request.requestId}
                      readOnly
                    />
                  </td>
                  <td className="px-4 py-2">{request.requestId || "—"}</td>
                  <td className="px-4 py-2">
                    {request.createdAt && !isNaN(Date.parse(request.createdAt))
                      ? new Date(request.createdAt).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }
                        )
                      : "—"}
                  </td>
                  <td className="px-4 py-2">{request.department || "—"}</td>
                  <td className="px-4 py-2">{request.positionType || "—"}</td>
                  <td className="px-4 py-2">{request.assigned || "—"}</td>
                  <td className="px-4 py-2">{request.positionTitle || "—"}</td>
                  <td className="px-4 py-2">{request.status || "—"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="p-4 text-center text-gray-500">
                  No requests available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ApprovalTable;
